import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

export default function Home() {
  const navigate = useNavigate();
  const [messages, setMessages] = useState([]);
  const [userName, setUserName] = useState("");
  const [showNameInput, setShowNameInput] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [userInput, setUserInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);

  // Start with all options available
  const allOptions = ["About", "Projects", "Contact", "Fun Facts"];
  const [remainingOptions, setRemainingOptions] = useState(allOptions);

  const initialMessages = [
    { type: "bot", content: "Hi, I'm Emily! 👋" },
    {
      type: "bot",
      content:
        "I'm a Computer Science & Finance Student at WashU, passionate about building AI/ML solutions and driving product execution.",
    },
    { type: "user-input", content: "What's your name?" },
  ];

  useEffect(() => {
    if (currentMessageIndex < initialMessages.length) {
      const delay = currentMessageIndex === 0 ? 1000 : 1500;
      const timer = setTimeout(() => {
        const current = initialMessages[currentMessageIndex];
        setMessages((prev) => [...prev, current]);
        setCurrentMessageIndex((prev) => prev + 1);

        if (current.type === "user-input") setShowNameInput(true);
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [currentMessageIndex]);

  const handleNameSubmit = (e) => {
    e.preventDefault();
    if (!userName.trim()) return;

    setMessages((prev) => [
      ...prev,
      { type: "user", content: `Hi Emily! Nice meeting you, I'm ${userName}` },
    ]);
    setShowNameInput(false);

    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          type: "bot",
          content: `Hey ${userName}, it's nice meeting you! Thanks for taking the time to learn about me.`,
        },
      ]);
    }, 1000);

    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          type: "bot",
          content:
            "From here, I'll let you pick what you want to learn about:",
        },
      ]);
      setShowOptions(true);
    }, 2000);
  };

  const handleOptionClick = (option) => {
    // Show user selected message
    setMessages((prev) => [...prev, { type: "user", content: option }]);
    setShowOptions(false);

    // Show bot info for selected option
    setTimeout(() => {
      let info = "";
      if (option === "About") {
        info =
          "Hey, I'm Emily! I'm a product person who loves building things that make lives easier. I started Quture and Pose, and I've worked at Mastercard and Recurrency.";
      } else if (option === "Projects") {
        info =
          "👗 Quture: AI-powered secondhand fashion platform\n📸 Pose: Real-time photography coaching app\nVisit: https://emilyhan0212.wixsite.com/website";
      } else if (option === "Fun Facts") {
        info =
          "🏸 6-time national badminton champion\n🍱 20,000+ followers on food app\n🥇 Former varsity golf captain\n🎶 Loves EDM & house music\n🥢 Beli streak: 10 weeks, 150+ restaurants";
      } else if (option === "Contact") {
        info =
          "You can contact Emily via email: emilyhan0212@gmail.com or connect on LinkedIn.";
      }

      setMessages((prev) => [...prev, { type: "bot", content: info }]);

      // Update remainingOptions - remove selected option
      setRemainingOptions((prev) =>
        prev.filter((opt) => opt !== option)
      );

      // Show options again if any left, else redirect
      setTimeout(() => {
        setMessages((prev) => [
          ...prev,
          {
            type: "bot",
            content: prev.length === 0
              ? "Redirecting you to my portfolio now..."
              : "Please choose another option or exit the chat.",
          },
        ]);

        if (remainingOptions.length - 1 > 0) {
          setShowOptions(true);
        } else {
          // No options left, redirect after short delay
          setTimeout(() => {
            navigate("/portfolio");
          }, 2000);
        }
      }, 1500);
    }, 1000);
  };

  // Scroll to bottom on new message
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, showOptions]);

  return (
    <div className="chat-container">
      <div className="chat-header">
        <div>
          <h1>Emily Han</h1>
          <p>everything product</p>
        </div>
      </div>

      <div className="chat-messages">
        {messages.map((msg, index) => (
          <div key={index} className={`message ${msg.type}`}>
            {msg.content}
          </div>
        ))}

        {/* Show options dynamically based on remainingOptions */}
        {showOptions && remainingOptions.length > 0 && (
          <div className="options-container">
            {remainingOptions.map((opt, i) => (
              <button key={i} onClick={() => handleOptionClick(opt)}>
                {opt}
              </button>
            ))}
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      <button
        onClick={() => navigate("/portfolio")}
        className="exit-btn"
        style={{
          margin: "20px auto",
          display: "block",
          padding: "10px 20px",
          backgroundColor: "#ccc",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontWeight: "bold",
          color: "#222"
        }}
      >
        Exit
      </button>

      {showNameInput && (
        <form className="input-form" onSubmit={handleNameSubmit}>
          <input
            type="text"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            placeholder="Type your name..."
            autoFocus
          />
          <button type="submit" className="send-btn">
            Send
          </button>
        </form>
      )}
    </div>
  );
}
